import { render, staticRenderFns } from "./PageCountConfig.vue?vue&type=template&id=30069128"
import script from "./PageCountConfig.vue?vue&type=script&lang=js"
export * from "./PageCountConfig.vue?vue&type=script&lang=js"
import style0 from "./PageCountConfig.vue?vue&type=style&index=0&id=30069128&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports